 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor","CasosDelegados":"CasosDelegados","admin":"admin","asignados":"asignados","aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540":"aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540","aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e":"aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e","aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364":"aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364","revisar_caso_empleado":"revisar_caso_empleado","revisar_caso_supervisor":"revisar_caso_supervisor","aud_reportes~empalmes":"aud_reportes~empalmes","aud_reportes":"aud_reportes","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889","crud_graficas":"crud_graficas","informacion_caso_supervisor":"informacion_caso_supervisor","inventario_documental":"inventario_documental","reporte_documental":"reporte_documental","reporte_workflow":"reporte_workflow","empalmes":"empalmes","buscar_documentos":"buscar_documentos","inicio_rol":"inicio_rol","crud_documentos":"crud_documentos","crud_sectores":"crud_sectores","crud_workflows~digitalizar~iniciar_caso":"crud_workflows~digitalizar~iniciar_caso","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"buscar_estado_documento~buscar_estado_documentos~iniciar_caso","iniciar_caso":"iniciar_caso","digitalizar":"digitalizar","rechazados":"rechazados","buscar_estado_documento":"buscar_estado_documento","buscar_estado_documentos":"buscar_estado_documentos","crud_workflows":"crud_workflows","info_usuarios":"info_usuarios","informacion_caso_empleado":"informacion_caso_empleado","login":"login","casos_empleados":"casos_empleados","casos_respondidos":"casos_respondidos","home_admin":"home_admin","home_rol":"home_rol","home_supervisor":"home_supervisor","informacion_caso_respondido":"informacion_caso_respondido","inicio":"inicio"}[chunkId]||chunkId) + "." + {"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"5a0c5774","CasosDelegados":"c174daad","admin":"4ab08213","asignados":"9b823a95","aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540":"e84b7b01","aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e":"74ed78ed","aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364":"34d64621","revisar_caso_empleado":"101b3f48","revisar_caso_supervisor":"46cf4a2c","aud_reportes~empalmes":"9fa1ca60","aud_reportes":"e2d95ff3","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"04ba1f2e","crud_graficas":"ccada06b","informacion_caso_supervisor":"b24b0246","inventario_documental":"f2275f04","reporte_documental":"bd957300","reporte_workflow":"978aa2aa","empalmes":"cde192a8","buscar_documentos":"256e775d","inicio_rol":"42457173","crud_documentos":"5d503ac9","crud_sectores":"6dc2e030","crud_workflows~digitalizar~iniciar_caso":"aae6a8f1","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"d70e6dd1","iniciar_caso":"46f3f3c6","digitalizar":"a8923660","rechazados":"e623c510","buscar_estado_documento":"0590c9d8","buscar_estado_documentos":"d2c3d9df","crud_workflows":"e77fc79f","info_usuarios":"5da0de0e","informacion_caso_empleado":"4bea77db","login":"3baafc29","casos_empleados":"d663ad7a","casos_respondidos":"fb6b43b5","home_admin":"06e6d0a1","home_rol":"b265567a","home_supervisor":"50d002d7","informacion_caso_respondido":"0323ba7b","inicio":"dee8b817","chunk-2d216214":"8ece6c8e","chunk-2d216257":"256ee085","chunk-733d8f46":"11b91543"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":1,"CasosDelegados":1,"admin":1,"asignados":1,"aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540":1,"aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e":1,"aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364":1,"revisar_caso_empleado":1,"revisar_caso_supervisor":1,"aud_reportes":1,"buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":1,"crud_graficas":1,"informacion_caso_supervisor":1,"inventario_documental":1,"reporte_workflow":1,"buscar_documentos":1,"inicio_rol":1,"crud_documentos":1,"crud_sectores":1,"crud_workflows~digitalizar~iniciar_caso":1,"buscar_estado_documento~buscar_estado_documentos~iniciar_caso":1,"iniciar_caso":1,"digitalizar":1,"rechazados":1,"buscar_estado_documento":1,"buscar_estado_documentos":1,"crud_workflows":1,"info_usuarios":1,"informacion_caso_empleado":1,"login":1,"casos_empleados":1,"casos_respondidos":1,"home_rol":1,"home_supervisor":1,"inicio":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor","CasosDelegados":"CasosDelegados","admin":"admin","asignados":"asignados","aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540":"aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540","aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e":"aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e","aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364":"aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364","revisar_caso_empleado":"revisar_caso_empleado","revisar_caso_supervisor":"revisar_caso_supervisor","aud_reportes~empalmes":"aud_reportes~empalmes","aud_reportes":"aud_reportes","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889","crud_graficas":"crud_graficas","informacion_caso_supervisor":"informacion_caso_supervisor","inventario_documental":"inventario_documental","reporte_documental":"reporte_documental","reporte_workflow":"reporte_workflow","empalmes":"empalmes","buscar_documentos":"buscar_documentos","inicio_rol":"inicio_rol","crud_documentos":"crud_documentos","crud_sectores":"crud_sectores","crud_workflows~digitalizar~iniciar_caso":"crud_workflows~digitalizar~iniciar_caso","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"buscar_estado_documento~buscar_estado_documentos~iniciar_caso","iniciar_caso":"iniciar_caso","digitalizar":"digitalizar","rechazados":"rechazados","buscar_estado_documento":"buscar_estado_documento","buscar_estado_documentos":"buscar_estado_documentos","crud_workflows":"crud_workflows","info_usuarios":"info_usuarios","informacion_caso_empleado":"informacion_caso_empleado","login":"login","casos_empleados":"casos_empleados","casos_respondidos":"casos_respondidos","home_admin":"home_admin","home_rol":"home_rol","home_supervisor":"home_supervisor","informacion_caso_respondido":"informacion_caso_respondido","inicio":"inicio"}[chunkId]||chunkId) + "." + {"CasosDelegados~buscar_documentos~inicio_rol~revisar_caso_empleado~revisar_caso_supervisor":"a6bc408c","CasosDelegados":"5c8076a7","admin":"8f6c4112","asignados":"5c8076a7","aud_reportes~buscar_documentos~buscar_estado_documento~buscar_estado_documentos~crud_documentos~crud~b0437540":"ce2af5c2","aud_reportes~buscar_documentos~crud_documentos~crud_graficas~crud_sectores~digitalizar~empalmes~info~57dc5b9e":"5bd79ce0","aud_reportes~crud_graficas~informacion_caso_supervisor~inventario_documental~reporte_documental~repo~4c19d364":"2090ba31","revisar_caso_empleado":"f3438ccd","revisar_caso_supervisor":"f3438ccd","aud_reportes~empalmes":"31d6cfe0","aud_reportes":"1accccda","buscar_documentos~crud_graficas~informacion_caso_supervisor~inicio_rol~inventario_documental~reporte~14fde889":"6134a656","crud_graficas":"49830f27","informacion_caso_supervisor":"b6511001","inventario_documental":"270191b6","reporte_documental":"31d6cfe0","reporte_workflow":"49830f27","empalmes":"31d6cfe0","buscar_documentos":"b55dbb90","inicio_rol":"f23ae725","crud_documentos":"2e22c147","crud_sectores":"28dec579","crud_workflows~digitalizar~iniciar_caso":"80cee6ef","buscar_estado_documento~buscar_estado_documentos~iniciar_caso":"55a82b9c","iniciar_caso":"4af19e76","digitalizar":"5deb0fe9","rechazados":"7798a7f8","buscar_estado_documento":"33ac40b1","buscar_estado_documentos":"1fca0cc0","crud_workflows":"28cd70b9","info_usuarios":"6c649c8b","informacion_caso_empleado":"9d21c0d7","login":"bf90f09d","casos_empleados":"5c8076a7","casos_respondidos":"5c8076a7","home_admin":"31d6cfe0","home_rol":"6acb22b4","home_supervisor":"5c8076a7","informacion_caso_respondido":"31d6cfe0","inicio":"5c8076a7","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-733d8f46":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
